"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TICKET_TYPES = exports.TICKET_LOG_TYPES = exports.SEARCH_CARD_TYPES = exports.MESSENGER_TYPES = exports.MESSAGE_STATUS = exports.MANAGER_STATUSES = exports.LOG_RELATIONS = exports.CLIENT_LOG_TYPES = exports.ALIGN = void 0;
var LOG_RELATIONS = exports.LOG_RELATIONS = {
  CLIENT: 'client',
  TICKET: 'ticket'
};
var TICKET_TYPES = exports.TICKET_TYPES = {
  COMMON_QUESTION: 'common_question',
  TOUR_SELECTION: 'tour_selection',
  UNKNOWN: 'unknown',
  UPDATING: 'updating',
  HOTLINE: 'hotline'
};

// Тип сообщения
var CLIENT_LOG_TYPES = exports.CLIENT_LOG_TYPES = {
  CALL: 'call',
  EMAIL: 'email',
  MESSAGE: 'message',
  NOTE: 'note',
  SMS: 'sms',
  MESSAGE_GROUP: 'message_group',
  MANAGER_EMAIL: 'manager_email'
};
var TICKET_LOG_TYPES = exports.TICKET_LOG_TYPES = {
  CREATE: 'create',
  GROUP: 'mail_group_id',
  MANAGER: 'manager_id',
  NOTE: 'note',
  STATUS: 'status',
  TYPE: 'type',
  TASK: 'task',
  NPS: 'request_nps_rating'
};
var SEARCH_CARD_TYPES = exports.SEARCH_CARD_TYPES = {
  CLIENTS: 'clients',
  ORDERS: 'orders',
  COMMUNICATION: 'communication',
  MESSAGES: 'messages'
};
var MESSAGE_STATUS = exports.MESSAGE_STATUS = {
  NONE: 'none',
  SENT: 'sent',
  RECEIVED: 'received',
  READ: 'read'
};
var MESSENGER_TYPES = exports.MESSENGER_TYPES = {
  INSTAGRAM: 'instagram',
  WHATSAPP: 'whatsapp',
  TELEGRAM: 'telegram',
  FACEBOOK_MESSENGER: 'facebook_messenger',
  FACEBOOK: 'facebook',
  VIBER: 'viber',
  MAIL: 'mail',
  VK: 'vk'
};
var ALIGN = exports.ALIGN = {
  AUTO: 'auto',
  SMART: 'smart',
  CENTER: 'center',
  END: 'end',
  START: 'start'
};
var MANAGER_STATUSES = exports.MANAGER_STATUSES = {
  AFTER_SERVICE: 'afterService',
  DND: 'dnd',
  IN_SERVICE: 'inService',
  OFFLINE: 'offline',
  ONLINE: 'online',
  READY: 'ready'
};